import React from "react";
import "./PreviewLink.css";
import { QRCodeSVG } from "qrcode.react";
import createGoogleAnalyticsTemplateName from "../../../helpers/createGoogleAnalyticsTemplateName";
import { TrackGoogleAnalyticsEvent } from "../../../helpers/InitializeGoogleAnalytics";

// This is a component to build a preview link to open in a new window and add the Google Analytics tracking.
const PreviewLink = ({ type, link, qr, name }) => {
  function openPreviewerLink() {
    window.open(`${link}`);
    TrackGoogleAnalyticsEvent(
      "click",
      `CTA PL ${type}: ${createGoogleAnalyticsTemplateName(name)}`,
      "click"
    );
  }

  return (
    <div className={"preview-link-box"}>
      <button
        className="preview-button"
        onClick={openPreviewerLink}
      >{`Preview ${type}`}</button>

      <div className={"qr-container"}>
        {!qr && <p>No QR code</p>}
        {qr && <QRCodeSVG value={link} size="87" />}
      </div>
    </div>
  );
};

export default PreviewLink;
